/** Phase 7B — SCR-BIZ-005–008 org structure bindings (07-02) */

export const ORG_STRUCTURE_SCREEN_IDS = [
  'SCR-BIZ-005',
  'SCR-BIZ-006',
  'SCR-BIZ-007',
  'SCR-BIZ-008',
] as const;

export type OrgStructureScreenId = (typeof ORG_STRUCTURE_SCREEN_IDS)[number];

export const ORG_STRUCTURE_ROUTES: Record<OrgStructureScreenId, string> = {
  'SCR-BIZ-005': '/department-list',
  'SCR-BIZ-006': '/department-editor',
  'SCR-BIZ-007': '/cost-centre-list',
  'SCR-BIZ-008': '/hierarchy-view',
};

export const ORG_STRUCTURE_PERMISSIONS: Partial<Record<OrgStructureScreenId, readonly string[]>> = {
  'SCR-BIZ-005': ['PERM-corporate.department.read'],
  'SCR-BIZ-006': ['PERM-corporate.department.manage'],
  'SCR-BIZ-007': ['PERM-corporate.costcentre.manage'],
  'SCR-BIZ-008': ['PERM-corporate.department.read'],
};

export const ORG_STRUCTURE_ENDPOINTS: Partial<Record<OrgStructureScreenId, readonly string[]>> = {
  'SCR-BIZ-005': ['GET /business/v1/departments'],
  'SCR-BIZ-006': [
    'GET /business/v1/departments',
    'POST /business/v1/departments',
    'PATCH /business/v1/departments/{id}',
    'DELETE /business/v1/departments/{id}',
  ],
  'SCR-BIZ-007': [
    'GET /business/v1/cost-centres',
    'POST /business/v1/cost-centres',
    'PATCH /business/v1/cost-centres/{id}',
    'DELETE /business/v1/cost-centres/{id}',
    'GET /business/v1/employees',
  ],
  'SCR-BIZ-008': ['GET /business/v1/departments'],
};

export const DEPARTMENT_ID_STORAGE_KEY = 'beatq.business.departmentId';

export const DEPARTMENT_READ_PERM = 'PERM-corporate.department.read';
export const DEPARTMENT_MANAGE_PERM = 'PERM-corporate.department.manage';
export const COST_CENTRE_MANAGE_PERM = 'PERM-corporate.costcentre.manage';
